import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { HiPlus } from 'react-icons/hi';
import { UploadIcon } from '../../../constant/imgImport';
import { useTusInvidualUpload } from '../../../hooks/useTusUpload';
import { IAddNewModal } from '../../../interfaces/components/modal.interface';
import UploadProgress from '../../modal/UploadProgress';
import {
  imgAcceptTypeUpload,
  notImgAcceptTypeUpload,
} from '../../../constant/fileType';
import ModifyFolderModal from '../../modal/training-module/ModifyFolderModal';
import BottomDrawer from '../../elements/drawers/BottomDrawer';
import { useQueryClient } from 'react-query';
import {
  FILES_LIST_MY_GROUP,
  FILES_LIST_MY_SPACE,
  FOLDER_INFO,
} from '../../../constant/QueryKeyName';

/**
 * This component use to create new folder or upload new file (doccen v1)
 */
const AddNewButton: React.FC<IAddNewModal> = ({
  uploadNewFile = true,
  queryKey = '',
  idSaveOn,
}) => {
  const queryClient = useQueryClient();
  const [openToast, setOpenToast] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { handleSetFiles, progress, fileList, currentFileIndex } =
    useTusInvidualUpload({
      idSaveOn: idSaveOn as string,
      onSuccess: () => {
        queryClient.refetchQueries([FILES_LIST_MY_SPACE]);
        queryClient.refetchQueries([FILES_LIST_MY_GROUP]);
        queryClient.refetchQueries([FOLDER_INFO]);
      },
      onError: () => {
        queryClient.refetchQueries([FILES_LIST_MY_SPACE]);
        queryClient.refetchQueries([FILES_LIST_MY_GROUP]);
        queryClient.refetchQueries([FOLDER_INFO]);
      },
    });

  const [openAddNewFolder, setOpenAddNewFolder] = useState<boolean>(false);

  const [uploadProgressOpen, setUploadProgressOpen] = useState<boolean>(false);
  const uploadInputRef = useRef<HTMLInputElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnClickUploadFile = () => {
    uploadInputRef.current?.click();
    handleClose();
  };

  // const handleClickAddNewFolder = () => {
  //   setOpenAddNewFolder(true);
  // };

  const checkFileSize = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.item(0); //doccen v1 chỉ upload 1 file
    if (file && file.size > 150 * 1024 * 1024) {
      //150mb
      setOpenToast(true);
    } else {
      handleSetFiles(event);
    }
    event.target.value = '';
  };

  useEffect(() => {
    fileList.length > 0 && setUploadProgressOpen(true);
  }, [fileList]);

  return (
    <>
      <input
        ref={uploadInputRef}
        style={{
          display: 'none',
        }}
        type="file"
        accept={notImgAcceptTypeUpload.concat(imgAcceptTypeUpload).join(', ')}
        onChange={checkFileSize}
      />
      <UploadProgress
        fileList={fileList}
        currentFileIndex={currentFileIndex}
        progress={progress}
        isOpen={uploadProgressOpen}
        toggle={() => setUploadProgressOpen((state) => !state)}
      />
      <Snackbar
        open={openToast}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        onClose={() => setOpenToast(false)}
        autoHideDuration={2000}
        disableWindowBlurListener={true}
        className={'bg-bg_toast text-white rounded-md px-9 py-4'}
      >
        <div>
          <p>Bạn không thể tải lên tệp với dung lượng lớn hơn 150MB</p>
        </div>
      </Snackbar>
      {/* desktop add new button */}
      <div className="hidden lg:block">
        <Button
          style={{ textTransform: 'none' }}
          size="small"
          id="add-new-button"
          aria-controls={open ? 'add-new-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className="!bg-primary_lighter !text-white !flex !gap-2 !text-sm !px-5 !py-2 !hover:bg-primary_lighter group !normal-case"
        >
          <div className="bg-primary_supa_lighter p-[2px] rounded-full">
            <HiPlus color="#ffffff" size={14} />
          </div>
          Thêm mới
        </Button>
      </div>
      {/* mobile add new button */}
      <button
        onClick={handleClick}
        id="add-new-button"
        className="lg:hidden bg-primary_lighter rounded-full cursor-pointer p-3"
      >
        <div className="w-[19px] h-[19px]">
          <Image src="/icons/plus.svg" width={18} height={18} alt="" />
        </div>
      </button>
      {/* desktop menu */}
      <Menu
        className="hidden lg:block"
        id="add-new-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'add-new-button',
        }}
      >
        {uploadNewFile && (
          <MenuItem
            onClick={handleOnClickUploadFile}
            className="flex gap-2 items-center"
          >
            <Image alt="upload-icon" src={UploadIcon} width={20} height={20} />
            Tải lên
          </MenuItem>
        )}
        {/* {addNewFolder && (
          <MenuItem
            onClick={handleClickAddNewFolder}
            className="flex gap-2 items-center"
          >
            <Image alt="folder-icon" src={FolderIcon} width={20} height={20} />
            Thư mục
          </MenuItem>
        )} */}
      </Menu>
      {/* mobile menu */}
      <BottomDrawer isOpen={open} handleClose={handleClose} title="Thêm mới">
        <div className="py-5">
          {uploadNewFile && (
            <MenuItem
              onClick={handleOnClickUploadFile}
              className="flex gap-2 items-center"
            >
              <Image
                alt="upload-icon"
                src={UploadIcon}
                width={20}
                height={20}
              />
              Tải lên
            </MenuItem>
          )}
          {/* {addNewFolder && (
          <MenuItem
            onClick={handleClickAddNewFolder}
            className="flex gap-2 items-center"
          >
            <Image alt="folder-icon" src={FolderIcon} width={20} height={20} />
            Thư mục
          </MenuItem>
        )} */}
        </div>
      </BottomDrawer>
      <ModifyFolderModal
        open={openAddNewFolder}
        setOpen={() => setOpenAddNewFolder(false)}
        queryKey={queryKey || ''}
      />
    </>
  );
};
export default AddNewButton;
